import axios from 'axios';
import {
  axiosCacheableAdapter,
  defaultCacheableSingleton,
} from 'src/lib/cacheable';

const NomadApiClient = axiosCacheableAdapter(
  axios.create({
    baseURL: process.env.NEXT_PUBLIC_NOMAD_API_URL,
  }),
  defaultCacheableSingleton
);

export default NomadApiClient;
